import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";
import { buildSectionPill } from "../../components/SectionPill.js";
import { createServicesStage } from "../../components/ServicesStage.js";
import { createHeroLogoMarquee } from "../../components/HeroLogoMarquee.js";
import { createHeroMemberMarquee } from "../../components/HeroMemberMarquee.js";

const checkIcon = `<svg class="hero__tag-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
  <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export function createServicesBannerSection(
  banner,
  { title = "Web Development", slug = "web-development" } = {}
) {
  const section = document.createElement("section");
  section.id = "banner";
  section.className = "section hero services-banner";

  const shell = document.createElement("div");
  shell.className = "section__inner hero__shell services-banner__shell";

  const grid = document.createElement("div");
  grid.className = "services-banner__grid";

  grid.innerHTML = `
    <div class="services-banner__content">
      ${buildSectionPill(banner.badge)}
      <h1 class="hero__title">${buildAnimatedTitle(banner.titleSegments)}</h1>
      <p class="hero__subtitle reveal" style="--delay: 0.08s">${banner.subtitle}</p>
      <div class="hero__actions reveal" style="--delay: 0.16s">
        <a class="btn btn--primary" href="${banner.ctaPrimaryHref}">${banner.ctaPrimary}</a>
        <a class="btn btn--ghost" href="${banner.ctaSecondaryHref}">${banner.ctaSecondary}</a>
      </div>
      <ul class="hero__tags reveal" style="--delay: 0.24s">
        ${banner.tags.map((tag) => `<li class="hero__tag">${checkIcon}${tag}</li>`).join("")}
      </ul>
    </div>
  `;

  grid.append(createServicesStage(slug));

  const marquee =
    slug === "staff-augmentation" ? createHeroMemberMarquee() : createHeroLogoMarquee();

  shell.innerHTML = `<p class="services-banner__watermark" aria-hidden="true">${title}</p>`;
  shell.append(grid, marquee);
  section.append(shell);
  return section;
}
